import React from 'react';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';

export type AppIconButtonProps = IconButtonProps;

/** MUI IconButton with design-system default `size="small"`. */
const AppIconButton = React.forwardRef(function AppIconButton(
  { size = 'small', ...props }: AppIconButtonProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  return <IconButton ref={ref} size={size} {...props} />;
}) as typeof IconButton;

export default AppIconButton;
